module.exports = __webpack_public_path__ + "img/8.972a5ea2.png";